import {
  LayoutDashboard, Users, Building2, Package, Target, GitBranch,
  MousePointerClick, TrendingUp, BarChart3, Wallet, Banknote,
  Megaphone, Webhook, Settings, Globe, CreditCard, ScrollText, Newspaper, Inbox, ServerCog, Waypoints, Facebook,
} from "lucide-react";

// Super Admin runs the SaaS — not a tenant's affiliate program.
export const SUPER_NAV_GROUPS = [
  {
    key: "nav.overview",
    items: [
      { to: "/", label: "Dashboard", icon: LayoutDashboard },
      { to: "/organizations", label: "Organizations", icon: Globe },
    ],
  },
  {
    key: "nav.system",
    items: [
      { to: "/billing", label: "Billing", icon: CreditCard },
      { to: "/system", label: "System", icon: ServerCog },
      { to: "/settings", label: "Settings", icon: Settings },
      { to: "/logs", label: "Logs", icon: ScrollText },
    ],
  },
];

export const NAV_GROUPS = [
  {
    key: "nav.overview",
    items: [
      { to: "/", label: "Dashboard", icon: LayoutDashboard, perm: "dashboard.view", section: "dashboard" },
      { to: "/organizations", label: "Organizations", icon: Globe, superOnly: true },
      { to: "/statistics", label: "Statistics", icon: BarChart3, perm: "statistics.view", section: "statistics" },
    ],
  },
  {
    key: "nav.crm",
    items: [
      { to: "/users", label: "Users", icon: Users, perm: "users.view", section: "users", counter: "users" },
      { to: "/advertisers", label: "Advertisers", icon: Building2, perm: "advertisers.view" },
      { to: "/products", label: "Products", icon: Package, perm: "products.view" },
    ],
  },
  {
    key: "nav.affiliate",
    items: [
      { to: "/offers", label: "Offers", icon: Target, perm: "offers.view", section: "offers" },
      { to: "/streams", label: "Streams", icon: GitBranch, perm: "streams.view", section: "streams" },
      { to: "/multilinks", label: "Multi Links", icon: Waypoints, perm: "streams.view", section: "streams" },
      { to: "/facebook", label: "Facebook", icon: Facebook, perm: "streams.view", section: "streams" },
      { to: "/requests", label: "Requests", icon: Inbox, perm: "offers.assign", counter: "requests" },
    ],
  },
  {
    key: "nav.tracking",
    items: [
      { to: "/clicks", label: "Clicks", icon: MousePointerClick, perm: "statistics.view", section: "clicks" },
      { to: "/conversions", label: "Conversions", icon: TrendingUp, perm: "statistics.view", section: "conversions" },
      { to: "/postbacks", label: "Postbacks", icon: Webhook, perm: "postbacks.view", section: "postbacks" },
    ],
  },
  {
    key: "nav.finance",
    items: [
      { to: "/finance", label: "Finance", icon: Wallet, perm: "finance.view", counter: "payouts" },
      { to: "/wallets", label: "Wallets", icon: Banknote, perm: "withdrawals.approve", counter: "wallets" },
    ],
  },
  {
    key: "nav.system",
    items: [
      { to: "/news", label: "News", icon: Newspaper, perm: "announcements.view", section: "announcements" },
      { to: "/logs", label: "Logs", icon: ScrollText, always: true },
      { to: "/settings", label: "Settings", icon: Settings, always: true },
    ],
  },
];
